import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Array<any>>()

    const getCategories = async () => {
        const res = await Api.get('admin/categories')
        if (res.status == 200) {
            data.value = res.data.categories
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    const remove = async (id: number) => {
        ElMessageBox.confirm("Eliminar?").then(async (y) => {
            loading.value = true
            const res = await Api.delete(`admin/categories/${id}`)
            if (res.status >= 200 && res.status < 300) {
                await getCategories()
                ElMessageBox.alert("Eliminado", {type: 'success'})
                loading.value = false
            } else {
                ElMessageBox.alert('Ocorreu um erro ao buscar os dados').finally(() => {
                    loading.value = false
                })
            }
        }).catch(() => {
            //
            loading.value = false
        })
    }
    onBeforeMount(async () => {
        await getCategories()
        loading.value = false
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 0) {
            await getCategories()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Categorias" }, {
      default: _withCtx(() => [
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ],
          data: data.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Criado por",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Criado em",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    tag: "router-link",
                    to: '/categories/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ]),
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: "Delete",
                    title: "Apagar",
                    onClick: ($event: any) => (remove(data.row.id))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})